import { render, staticRenderFns } from "./LoginForgot.vue?vue&type=template&id=0fff5564&"
import script from "./LoginForgot.vue?vue&type=script&lang=js&"
export * from "./LoginForgot.vue?vue&type=script&lang=js&"
import style0 from "./LoginForgot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports